
<div class="ratingStars">
  <span
    v-for="star in stars"
    :key="star"
    @click="rate(star)"
    :class="{'rated': star <= value, 'unrated': star > value}"
  >
    <i class="fas fa-star"></i>
  </span>
</div>
